import { FormikProps } from 'formik';
import React from 'react';
import { useOnMount } from '../../../helpers/hooks/useOnMount';
import { PrimaryProgressButton } from '../../../shared/Button';
import { Form, FormButtonRow } from '../../../shared/form/Form';
import { BillOfMaterialsContext } from '../../bill-of-materials/BillOfMaterialsContext';
import { HeatPumpBillOfMaterialsFields } from '../../bill-of-materials/HeatPumpBillOfMaterialsFields';
import { SolarBillOfMaterialsFields } from '../../bill-of-materials/SolarBillOfMaterialsFields';
import { UnderfloorHeatingBillOfMaterialsFields } from '../../bill-of-materials/UnderfloorHeatingBillOfMaterialsFields';
import { DataForEditDesignBillOfMaterialsForm } from './dataForEditDesignBillOfMaterialsForm';
import { EditDesignBillOfMaterialsFormModel } from './editDesignBillOfMaterialsFormModel';

export type NextStepAfterSavingBillOfMaterials = 'BackToProject' | 'UploadToNetSuite';

type Props = {
  data: DataForEditDesignBillOfMaterialsForm;
  setNextStepAfterSave: (nextStep: NextStepAfterSavingBillOfMaterials) => void;
} & FormikProps<EditDesignBillOfMaterialsFormModel>;

export const EditDesignBillOfMaterialsForm = (props: Props) => {
  useOnMount(() => {
    props.validateForm(props.values);
  });

  return (
    <Form>
      <BillOfMaterialsContext.Provider
        value={{
          isUsingLegacyPricingModel: true,
          customerTypeOptions: [],
        }}
      >
        {props.data.hasUnderfloorHeating && (
          <UnderfloorHeatingBillOfMaterialsFields
            units={props.values.units}
            controlOptionalExtras={props.values.underfloorHeatingControlOptionalExtras}
            floorConstructionOptionalExtras={props.values.underfloorHeatingFloorConstructionOptionalExtras}
            cylinderOptionalExtras={props.values.underfloorHeatingCylinderOptionalExtras}
            partsById={props.data.partsById}
            setFieldValue={props.setFieldValue}
            setFieldTouched={props.setFieldTouched}
            errors={props.errors}
            salesOrderNotes={props.data.underfloorHeatingSalesOrderNotes}
            isQuote={false}
          />
        )}
        {props.data.hasHeatPump && (
          <HeatPumpBillOfMaterialsFields
            units={props.values.units}
            heatPumpOptionalExtras={props.values.heatPumpOptionalExtras}
            partsById={props.data.partsById}
            setFieldValue={props.setFieldValue}
            setFieldTouched={props.setFieldTouched}
            errors={props.errors}
            salesOrderNotes={props.data.heatPumpSalesOrderNotes}
            isQuote={false}
          />
        )}
        {props.data.hasSolar && (
          <SolarBillOfMaterialsFields
            units={props.values.units}
            solarOptionalExtras={props.values.solarOptionalExtras}
            partsById={props.data.partsById}
            setFieldValue={props.setFieldValue}
            setFieldTouched={props.setFieldTouched}
            errors={props.errors}
            salesOrderNotes={props.data.solarSalesOrderNotes}
            isQuote={false}
          />
        )}
        <FormButtonRow $align="left">
          <PrimaryProgressButton
            type="submit"
            inProgress={props.isSubmitting}
            onClick={() => props.setNextStepAfterSave('BackToProject')}
          >
            Save
          </PrimaryProgressButton>
          <PrimaryProgressButton
            type="submit"
            inProgress={props.isSubmitting}
            onClick={() => props.setNextStepAfterSave('UploadToNetSuite')}
          >
            Save and Upload
          </PrimaryProgressButton>
        </FormButtonRow>
      </BillOfMaterialsContext.Provider>
    </Form>
  );
};
